import { Injectable } from '@angular/core';
import { SpaAppDataService } from './spa-app-data.service';
import { interval } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './http.service';
import { environment } from 'environments/environment';
import { CommonDataService } from 'modules/group/shared/commonData.service';

const AZURE_BLOB_STORAGE_URL = '/generateAzureBlobStorageSAS';
const ADMIN_SERVICE_URL = '/wbe-admin-service';
@Injectable({
  providedIn: 'root',
})
export class SpaAppInitializerService {
  public tenantId: string = '';
  public propertyId: string = '';
  public configURL: string = '';
  public middlewareAPIDomain: string = '';
  public appName: string = 'spa';
  public serviceHeaders: object = {};
  public tenantFound: boolean = false;
  public azureBlobToken = '';
  private isHtml2PdfBundleLoaded = false;

  //ServiceNames
  public adminService: String = '/wbe-admin-service/generatetoken/v2/tenants/';
  public old_adminService: string = '/wbe-admin-service/generatetoken/tenants/';
  public isAzureB2CAuthenticationEnabled: boolean = false;

  constructor(
    public appData: SpaAppDataService,
    public httpService: HttpService,
    private http: HttpClient,
    private commonDataService: CommonDataService
  ) {
    if (environment.isAzureB2CAuthenticationEnabled === 'true') {
      this.isAzureB2CAuthenticationEnabled = true;
    }
  }

  initializeApp(azureBlobTokenKey): Promise<any> {
    this.azureBlobToken = azureBlobTokenKey;
    // return ;
    return new Promise<void>((resolve, reject) => {
      this.loadHtml2PdfBundle();
      this.setConfigurations();
      this.tenantPropertyMapping();
      // this.setAzureBlobStorageToken();
      // this.updateAzureBlobStorageToken();
      this.resolveAPI()
        .then((response) => {
          resolve();
        })
        .catch((error) => {
          resolve();
        });
    });
  }

  private loadHtml2PdfBundle(): void {
    if (this.azureBlobToken) {
      const pdfUrl = this.configURL + '/config/assets/scripts/html2pdf.bundle.min.js' + '?' + this.azureBlobToken;

      this.http
        .get(pdfUrl, { responseType: 'blob' })
        .toPromise()
        .then((response) => {
          this.isHtml2PdfBundleLoaded = true;
          var head = document.getElementsByTagName('head')[0];

          var script = document.createElement('script');
          script.type = 'text/javascript';
          head.appendChild(script);

          const reader = new FileReader();
          reader.onload = () => {
            script.src = <string>reader.result;
          };
          reader.readAsDataURL(response);
        });
    }
  }

  async processConfig() {
    await this.appData.load(this.middlewareAPIDomain, this.tenantId, this.propertyId, this.appName, this.serviceHeaders).then(() => {
      return true;
    });
  }

  async resolveAPI() {
    let adminTokenURL;

    if (this.tenantId && this.propertyId) {
      //Generate new token every 5 minutes.
      interval(12 * 60 * 1000)
        .pipe(flatMap(() => this.initializeDate(adminTokenURL)))
        .subscribe((adminData) => {
          if (adminData['success']) {
            let serviceHeaders = {
              'Cache-Control': 'no-cache',
              Pragma: 'no-cache',
              Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
            };
            this.serviceHeaders = {
              headers: serviceHeaders,
            };
          }
        });
      var servicePath: String = this.isAzureB2CAuthenticationEnabled ? this.adminService : this.old_adminService;
      adminTokenURL =
        this.middlewareAPIDomain + servicePath + this.tenantId + '/propertyId/' + this.propertyId + '/appName/' + this.appName;
      let initData = await this.initializeDate(adminTokenURL).then(async (data) => {
        if (data) {
          let serviceHeaders = {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
          };
          this.serviceHeaders = {
            headers: serviceHeaders,
          };
          let processConfigRes = await this.processConfig().then(() => {
            return true;
          });
          return processConfigRes;
        } else {
          return true;
        }
      });
      return initData;
    } else {
      this.tenantFound = false;
      return true;
    }
  }

  async initializeDate(adminTokenURL) {
    let secondaryPromise = await this.getXtoken(adminTokenURL + '?' + new Date().getTime()).then(
      (data) => {
        this.tenantFound = true;
        this.commonDataService.token = data.token;
        return data;
      },
      (error) => {
        this.tenantFound = false;
      }
    );

    return secondaryPromise;
  }

  getXtoken(adminTokenURL) {
    return this.httpService.get(adminTokenURL + '&appName=spa').toPromise();
  }

  setConfigurations() {
    let hostname = document.location.hostname;

    this.configURL = environment.azureAccountUrl;
    if (environment.showLogs) {
      console.log('Environent data - azureAccountUrl :  ', environment.azureAccountUrl);
      console.log('Environent data - showLogs :  ', environment.showLogs);
      console.log('Environent data - proxy :  ', environment.proxy);
      console.log('Environent data - node api url', environment.nodeApiUrl);
    } else {
      if (window) {
        window.console.log = function () {};
      }
    }
    if (environment.proxy) {
      this.httpService.proxy = environment.proxy;
      this.httpService.apiUrl = environment.nodeApiUrl;
      this.middlewareAPIDomain = environment.backendApiUrl;
    } else {
      this.middlewareAPIDomain = window.location.protocol + '//' + hostname;
    }
  }

  tenantPropertyMapping() {
    if (location.pathname != '/') {
      let pathData = location.pathname.split('/');
      this.tenantId = pathData[2];
      this.propertyId = pathData[3];
      if (pathData[1] == 'spa') {
        this.tenantId = pathData[3];
        this.propertyId = pathData[4];
      }
    }
  }

  // /**
  //  * Returns azure blob token response.
  //  * @returns
  //  */
  // private getAzureBlobStorageToken(): Promise<any> {
  //   const url = this.middlewareAPIDomain + ADMIN_SERVICE_URL + AZURE_BLOB_STORAGE_URL;
  //   return this.httpService.get(url).toPromise();
  // }

  // /**
  //  * Sets azure blob storage token if the token response is valid.
  //  */
  // private async setAzureBlobStorageToken(): Promise<any> {
  //   const tokenResponse = await this.getAzureBlobStorageToken();
  //   if (tokenResponse.success) {
  //     this.azureBlobToken = tokenResponse.token;
  //     if (!this.isHtml2PdfBundleLoaded) {
  //       this.loadHtml2PdfBundle();
  //     }
  //   }
  // }

  // /**
  //  * Updates azure blob storage token for every three minutes.
  //  */
  // private updateAzureBlobStorageToken(): void {
  //   setInterval(() => {
  //     this.setAzureBlobStorageToken();
  //   }, 3 * 60 * 1000);
  // }
}
